import { EditorTools } from "@progress/kendo-react-editor";
import { paletteSettings, tooltip } from "../../config/constants";
import { editorToolType } from "../editor.Constant";
import CustomBookmark from "../editorTools/BookmarkTool";
import EditorAlignmentTool from "../editorTools/EditorAlignmentTool";
import EditorCanvas from "../editorTools/EditorCanvas";
import EditorHyperLinkTool from "../editorTools/EditorHyperLinkTool";
import EditorPrintPdfTool from "../editorTools/EditorPrintPdfTool";
import EditorScriptTool from "../editorTools/EditorScriptTool";
import EditorTableTools from "../editorTools/EditorTableTools";
import FileUploadTool from "../editorTools/FileUploadTool";
import GroupedInsertMedia from "../editorTools/GroupedInsertMedia";
import GroupedTools from "../editorTools/GroupedTools";
import { CustomFontNameTool } from "../editorTools/CustomFontNameTool";
import  CustomFontSizeTool  from "../editorTools/CustomFontSizeTool";
import { CustomFormatBlockTool } from "../editorTools/CustomFormatBlock";

const CustomForeColor = (props) => (
  <div title={tooltip.TEXT_COLOR}>
    <ForeColor
      {...props}
      colorPickerProps={{
        title: "ForeColorTitle",
        view: "palette",
        icon: "foreground-color",
        paletteSettings: paletteSettings,
        defaultValue: "green",
      }}
    />
  </div>
);
const CustomBackColor = (props) => (
  <div title={tooltip.HIGHLIGHT_COLOR}>
    <BackColor
      {...props}
      colorPickerProps={{ title: "BackColorTitle", view: "palette", icon: "background", paletteSettings: paletteSettings, defaultValue: "blue" }}
    />
  </div>
);
const {
  Bold,
  Italic,
  Underline,
  Strikethrough,
  AlignLeft,
  AlignCenter,
  AlignRight,
  AlignJustify,
  Indent,
  Outdent,
  OrderedList,
  UnorderedList,
  NumberedList,
  BulletedList,
  Undo,
  Redo,
  Link,
  Unlink,
  TableProperties,
  TableCellProperties,
  MergeCells,
  SplitCell,
  ForeColor,
  BackColor,
  CleanFormatting,
  FontName,
  FontSize,
  FormatBlock,
} = EditorTools;

/**
 * Array containing tools for the task sidebar editor.
 * These tools are used for text formatting, alignment, lists, undo/redo, links, images, viewing HTML, and cleaning formatting.
 */
export const tools = [
  Bold,
  Italic,
  Underline,
  Strikethrough,
  EditorScriptTool,
  EditorAlignmentTool,
  Indent,
  Outdent,
  NumberedList,
  BulletedList,
  Undo,
  Redo,
  EditorHyperLinkTool,
  GroupedInsertMedia,
  GroupedTools,
  EditorTableTools,
  TableProperties,
  TableCellProperties,
  MergeCells,
  SplitCell,
  CustomForeColor,
  CustomBackColor,
  EditorPrintPdfTool,
  EditorCanvas,
];

/**
 * Array containing tools for the task sidebar editor.
 * These tools are used for text formatting, alignment, lists, undo/redo, links, images, viewing HTML, and cleaning formatting.
 */
export const taskSidebartools = [
  [
    CustomForeColor,
    CustomBackColor,
    CleanFormatting,
    AlignLeft,
    AlignCenter,
    AlignRight,
    AlignJustify,
    OrderedList,
    UnorderedList,
    Indent,
    Outdent,
    Undo,
    Redo,
  ],
];

/**
 * provides toolbar for Editor
 * @params {String}
 */
export const toolbarList = (tool) => {
  if (tool === editorToolType.TASK_SIDEBAR_TOOL) {
    return [...taskSidebartools];
  } else if (tool === editorToolType.TASK_POPUP_TOOL) {
    return [...tools, CustomBookmark];
  } else if (tool === editorToolType.DOX_TOOL) {
    return [ CustomFontNameTool, FontSize, CustomFormatBlockTool, ...tools, CustomBookmark];
  } else return tools;
};

/**
 * Array containing tools for the form editor.
 */
export const formTools = [
  [Bold, Italic, Underline],
  [EditorAlignmentTool],
  [NumberedList],
  [BulletedList],
  [Indent],
  [Outdent],
  [CustomForeColor],
  [CustomBackColor],
  [Link, Unlink],
  [CustomFontSizeTool],
  [CustomFontNameTool],
  [FileUploadTool],
];